import { unsafeCSS as w, LitElement as B, html as s, nothing as k } from "lit";
import { state as b, property as h, queryAll as $ } from "lit/decorators.js";
import { repeat as A } from "lit/directives/repeat.js";
import "@justeattakeaway/pie-button";
import "@justeattakeaway/pie-divider";
import "@justeattakeaway/pie-icon-button";
import "@justeattakeaway/pie-link";
import "@justeattakeaway/pie-modal";
import "@justeattakeaway/pie-switch";
import { defineCustomElement as C, dispatchCustomEvent as f } from "@justeattakeaway/pie-webc-core";
const T = `*,*:after,*:before{box-sizing:inherit}*{margin:0}.c-cookieBanner{--cb-font-family: var(--dt-font-interactive-l-family);--cb-font-size: calc(var(--dt-font-body-l-size) * 1px);--cb-line-height: calc(var(--dt-font-body-l-line-height) * 1px);--cb-font-weight: var(--dt-font-body-l-weight);--cb-padding-inline: var(--dt-spacing-d);--cb-padding-block: var(--dt-spacing-d);--cb-offset: 0;color-scheme:only dark;background-color:var(--dt-color-background-dark);color:var(--dt-color-content-inverse);font-family:var(--cb-font-family);font-size:var(--cb-font-size);line-height:var(--cb-line-height);font-weight:var(--cb-font-weight);padding-block-start:var(--cb-padding-block);padding-block-end:var(--cb-padding-block);max-height:432px;position:fixed;bottom:var(--cb-offset);left:var(--cb-offset);right:var(--cb-offset);border-top-left-radius:var(--dt-radius-rounded-c);border-top-right-radius:var(--dt-radius-rounded-c);z-index:var(--dt-z-index-cookie-banner)}@media (min-width: 700px) and (orientation: landscape){.c-cookieBanner{--cb-padding-inline: var(--dt-spacing-f);--cb-offset: var(--dt-spacing-d);max-height:90%;border-bottom-left-radius:var(--dt-radius-rounded-c);border-bottom-right-radius:var(--dt-radius-rounded-c)}}.c-cookieBanner[isCookieBannerHidden]{display:none}.c-cookieBanner-title,.c-cookieBanner-body,.c-cookieBanner-actions{padding-inline-start:var(--cb-padding-inline);padding-inline-end:var(--cb-padding-inline)}.c-cookieBanner-title{--cb-title-font-size: var(--dt-font-heading-s-size--narrow);--cb-title-line-height: var(--dt-font-heading-s-line-height--narrow);font-size:calc(var(--cb-title-font-size) * 1px);font-weight:var(--dt-font-heading-s-weight);line-height:calc(var(--cb-title-line-height) * 1px)}@media (min-width: 700px) and (orientation: landscape){.c-cookieBanner-title{--cb-title-font-size: var(--dt-font-heading-s-size--wide);--cb-title-line-height: var(--dt-font-heading-s-line-height--wide)}}.c-cookieBanner-body{--cb-scroll-shadow-color: var(--dt-color-black);margin-block-start:var(--dt-spacing-a);max-height:200px;overflow-y:auto;background:linear-gradient(to bottom,transparent,var(--dt-color-background-dark) 75%) center bottom,linear-gradient(transparent,var(--cb-scroll-shadow-color)) center bottom;background-repeat:no-repeat;background-size:100% 48px,100% 8px;background-attachment:local,scroll}@media (min-width: 700px) and (orientation: landscape){.c-cookieBanner-body{max-height:150px}}.c-cookieBanner-actions{--cb-actions-flex-dir: column;margin-block-start:var(--dt-spacing-d);display:flex;gap:var(--dt-spacing-d);flex-direction:var(--cb-actions-flex-dir)}.c-cookieBanner-actions>pie-link{text-align:center;align-self:center}@media (min-width: 700px) and (orientation: landscape){.c-cookieBanner-actions{--cb-actions-flex-dir: row-reverse;justify-content:flex-start;align-items:center}}.c-cookieBanner-subheading{--cb-subheading-font-size: var(--dt-font-heading-s-size--narrow);--cb-subheading-line-height: var(--dt-font-heading-s-line-height--narrow);font-size:calc(var(--cb-subheading-font-size) * 1px);font-weight:var(--dt-font-heading-s-weight);line-height:calc(var(--cb-subheading-line-height) * 1px)}@media (min-width: 700px) and (orientation: landscape){.c-cookieBanner-subheading{--cb-subheading-font-size: var(--dt-font-heading-s-size--wide);--cb-subheading-line-height: var(--dt-font-heading-s-line-height--wide)}}.c-cookieBanner-description{font-size:calc(var(--dt-font-body-s-size) * 1px);line-height:calc(var(--dt-font-body-s-line-height) * 1px)}.c-cookieBanner-preference{display:flex;gap:var(--dt-spacing-d);justify-content:space-between;margin-block-start:var(--dt-spacing-e);margin-block-end:var(--dt-spacing-e)}.c-cookieBanner-preference p{margin-block-start:var(--dt-spacing-b)}.c-cookieBanner-preference:last-child{margin-block-end:0}
`, O = "pie-cookie-banner-accept-all", S = "pie-cookie-banner-necessary-only", M = "pie-cookie-banner-manage-prefs", N = "pie-cookie-banner-prefs-saved", P = [
  {
    id: "all",
    hasDivider: !0,
    hasDescription: !1
  },
  {
    id: "necessary",
    checked: !0,
    disabled: !0,
    hasDescription: !0
  },
  {
    id: "functional",
    hasDescription: !0
  },
  {
    id: "analytical",
    hasDescription: !0
  },
  {
    id: "personalized",
    hasDescription: !0
  }
];
function m(a) {
  console.error(`[localisation-utils]: ${a}`);
}
function z(a, e) {
  const n = (t) => String.prototype.split.call(e, t).filter(Boolean).reduce((o, r) => o != null && typeof o == "object" ? o[r] : o, a), i = n(/[,[\]]+?/) || n(/[,[\].]+?/);
  return typeof i != "string" ? "" : i;
}
function y(a, e) {
  if (!a)
    throw new Error('"locale" parameter cannot be empty');
  if (!e)
    throw new Error('"key" parameter cannot be empty');
  const n = z(a, e);
  return n || (m(`Couldn't find a value for the key "${e}", it will be used as fallback.`), e);
}
function E(a) {
  const n = a.map((t) => `(<${t}.*>.*</${t}>)`).join("|");
  return new RegExp(n, "igm");
}
function L(a, e) {
  const n = Object.keys(e);
  if (n.length === 0)
    return [a];
  const i = E(n);
  return a.split(i).filter((t) => !!t).map((t) => {
    if (!t.match(i))
      return t;
    const r = t.match(/<(.*)>(.*)<\/.*>/);
    if (!r)
      return t;
    const [, p, l] = r;
    return [p, l];
  }).map((t) => {
    if (!Array.isArray(t))
      return t;
    const [r, p] = t, l = e[r];
    return l || typeof l == "function" ? l(p) : (m(`Custom tag "${r}" does not have a matching enhancer function`), p);
  });
}
function R(a, e, n) {
  if (!a)
    throw new Error('"locale" parameter cannot be empty');
  if (!e)
    throw new Error('"key" parameter cannot be empty');
  if (!n)
    throw new Error('"customTagEnhancers" parameter cannot be empty');
  const i = y(a, e);
  return L(i, n);
}
const j = {
  title: "Cookies",
  description: "We use our own and third party cookies and other tech to enhance and personalise your user experience, optimize analytics, and show ads with third parties (read our <linkStatement>Statement</linkStatement>). Necessary cookies are always set. Click <linkNecessaryOnly>Necessary only</linkNecessaryOnly> to continue without accepting more. Click <linkManagePreferences>Manage preferences</linkManagePreferences> to share your preferences or <linkAcceptAll>Accept all</linkAcceptAll>.",
  cta: {
    managePreferences: "Manage preferences",
    necessaryOnly: "Necessary only",
    acceptAll: "Accept all"
  }
}, H = {
  title: "Manage your preferences",
  description: "You can find all the information in the <linkCookieStatement>Cookie Statement</linkCookieStatement> and <linkCookieTechList>Cookie technology list</linkCookieTechList>.",
  all: {
    title: "Turn all on"
  },
  necessary: {
    title: "Necessary",
    description: "These cookies are necessary to ensure that the website and its features function properly. Services you have asked for cannot be provided without these cookies."
  },
  functional: {
    title: "Functional",
    description: "These cookies allow the website to remember the choices you make to give you better functionality and personal features."
  },
  analytical: {
    title: "Analytical",
    description: "These analytical cookies, including statistics, are used to understand how visitors interact with the website and we can measure and improve the performance of our website."
  },
  personalized: {
    title: "Personalised (targeting and advertising)",
    description: "These marketing cookies are used to tailor the delivery of information to you based upon your interest and to measure the effectiveness of such advertisements, both on our website and our advertising partners' websites."
  },
  cta: {
    save: {
      label: "Save",
      ariaLabel: ""
    }
  }
}, D = {
  banner: j,
  preferencesManagement: H
};
var K = Object.defineProperty, F = Object.getOwnPropertyDescriptor, d = (a, e, n, i) => {
  for (var t = i > 1 ? void 0 : i ? F(e, n) : e, o = a.length - 1, r; o >= 0; o--)
    (r = a[o]) && (t = (i ? r(e, n, t) : r(t)) || t);
  return i && t && K(e, n, t), t;
};
const V = "pie-cookie-banner";
class c extends B {
  constructor() {
    super(...arguments), this._isCookieBannerHidden = !1, this._isModalOpen = !1, this.hasPrimaryActionsOnly = !1, this.defaultPreferences = {}, this.locale = D, this.cookieStatementLink = "", this.cookieTechnologiesLink = "", this._customTagEnhancers = {
      linkStatement: (e) => s`<pie-link href="${this.cookieStatementLink}" variant="inverse" target="_blank" data-test-id="cookie-statement-link">${e}</pie-link>`,
      linkNecessaryOnly: (e) => s`<pie-link data-test-id="body-necessary-only" tag="button" variant="inverse" @click="${this._onNecessaryOnly}">${e}</pie-link>`,
      linkManagePreferences: (e) => s`<pie-link data-test-id="body-manage-prefs" tag="button" variant="inverse" @click="${this._openManagePreferencesModal}">${e}</pie-link>`,
      linkAcceptAll: (e) => s`<pie-link data-test-id="body-accept-all" tag="button" variant="inverse" @click="${this._onAcceptAll}">${e}</pie-link>`,
      linkCookieStatement: (e) => s`<pie-link href="${this.cookieStatementLink}" size="small" target="_blank" data-test-id="cookie-statement-link">${e}</pie-link>`,
      linkCookieTechList: (e) => s`<pie-link href="${this.cookieTechnologiesLink}" size="small" target="_blank" data-test-id="cookie-technology-link">${e}</pie-link>`
    }, this._onNecessaryOnly = () => {
      f(this, S), this._isCookieBannerHidden = !0;
    }, this._onAcceptAll = () => {
      f(this, O), this._isCookieBannerHidden = !0;
    }, this._openManagePreferencesModal = () => {
      this._isCookieBannerHidden = !0, f(this, M), this._isModalOpen = !0;
    }, this._handleSwitchStates = (e) => {
      const { id: n } = e == null ? void 0 : e.currentTarget, i = [...this._preferencesNodes].find(({ id: t }) => t === "all");
      if (n === i.id) {
        const { checked: t } = e.target;
        this._preferencesNodes.forEach((o) => {
          o.checked = o.disabled ? o.checked : t;
        });
      } else
        i.checked = [...this._preferencesNodes].filter(({ id: t }) => t !== "all").every(({ checked: t }) => t);
    };
  }
  _localiseText(e) {
    return y(this.locale, e);
  }
  _localiseRichText(e) {
    return R(this.locale, e, this._customTagEnhancers);
  }
  /**
   * Handles closing the modal and re-displaying the cookie banner
   * and making the cookie banner visible
   */
  _displayCookieBanner() {
    this._isModalOpen = !1, this._isCookieBannerHidden = !1;
  }
  /**
   * Handles saving the user cookie preferences, closing the modal and the cookie banner
   * Creates a state object for the save event, indicating the checked status
   * of each preference except for the `all` preference.
   * @example {
   *  functional: false,
   *  necessary: true
   * }
   */
  _handlePreferencesSaved() {
    let e = {};
    [...this._preferencesNodes].filter(({ id: n }) => n !== "all").forEach(({ id: n, checked: i }) => {
      e = { ...e, [n]: i };
    }), f(this, N, e), this._isModalOpen = !1, this._isCookieBannerHidden = !0;
  }
  /**
   * Renders the content of the preference item.
   * @private
   */
  renderPreference({
    id: e,
    checked: n,
    disabled: i,
    hasDivider: t,
    hasDescription: o
  }) {
    var g;
    const r = this._localiseText(`preferencesManagement.${e}.title`), p = `preferencesManagement.${e}.description`, l = o && this._localiseText(p), _ = ["functional", "personalized", "analytical"].every((x) => {
      var u;
      return ((u = this.defaultPreferences) == null ? void 0 : u[x]) === !0;
    });
    return s`
            <div class="c-cookieBanner-preference">
                <div>
                    <h3 class="c-cookieBanner-subheading">${r}</h3>
                     ${l ? s`<p class="c-cookieBanner-description">${l}</p>` : k}
                 </div>
                <pie-switch
                    id="${e}"
                    ?checked="${((g = this.defaultPreferences) == null ? void 0 : g[e]) || _ || n}"
                    ?disabled="${i}"
                    @change="${this._handleSwitchStates}">
                </pie-switch>
            </div>
            ${t ? s`<pie-divider></pie-divider>` : k}`;
  }
  /**
   * Renders the modal content.
   * @private
   */
  renderModalContent() {
    return s`
            <p class="c-cookieBanner-description" data-test-id="modal-description">
                ${this._localiseRichText("preferencesManagement.description")}
            </p>
            ${A(
      P,
      ({ id: e }) => e,
      (e) => this.renderPreference(e)
    )}`;
  }
  render() {
    const e = {
      text: this._localiseText("preferencesManagement.cta.save.label"),
      variant: "primary",
      ariaLabel: this._localiseText("preferencesManagement.cta.save.label")
      // TODO: Replace with the appropriate "ariaLabel" as soon as the spreadsheet is updated
    };
    return s`
        <pie-modal
            .isOpen="${this._isModalOpen}"
            hasBackButton
            hasStackedActions
            isFullWidthBelowMid
            heading="${this._localiseText("preferencesManagement.title")}"
            .leadingAction="${e}"
            @pie-modal-leading-action-click="${this._handlePreferencesSaved}"
            @pie-modal-back="${this._displayCookieBanner}">
                ${this.renderModalContent()}
        </pie-modal>
        <aside data-test-id="pie-cookie-banner" class="c-cookieBanner" ?isCookieBannerHidden=${this._isCookieBannerHidden}>
            <h2 class="c-cookieBanner-title">${this._localiseText("banner.title")}</h2>
            <div class="c-cookieBanner-body" data-test-id="banner-description">
                <p>${this._localiseRichText("banner.description")}</p>
            </div>

            <div class="c-cookieBanner-actions">
                <pie-button
                    data-test-id="actions-accept-all"
                    @click="${this._onAcceptAll}"
                    variant="primary"
                    isFullWidth
                    size="small-expressive">
                    ${this._localiseText("banner.cta.acceptAll")}
                </pie-button>
                <pie-button
                    data-test-id="actions-necessary-only"
                    @click="${this._onNecessaryOnly}"
                    variant="${this.hasPrimaryActionsOnly ? "primary" : "outline-inverse"}"
                    isFullWidth
                    size="small-expressive">
                    ${this._localiseText("banner.cta.necessaryOnly")}
                </pie-button>
                <pie-link
                    data-test-id="actions-manage-prefs"
                    @click="${this._openManagePreferencesModal}"
                    tag="button"
                    variant="inverse"
                    isBold="true">
                    ${this._localiseText("banner.cta.managePreferences")}
                </pie-link>
            </div>
        </aside>`;
  }
}
c.styles = w(T);
d([
  b()
], c.prototype, "_isCookieBannerHidden", 2);
d([
  b()
], c.prototype, "_isModalOpen", 2);
d([
  h({ type: Boolean })
], c.prototype, "hasPrimaryActionsOnly", 2);
d([
  h({ type: Object })
], c.prototype, "defaultPreferences", 2);
d([
  h({ type: Object })
], c.prototype, "locale", 2);
d([
  h({ type: String })
], c.prototype, "cookieStatementLink", 2);
d([
  h({ type: String })
], c.prototype, "cookieTechnologiesLink", 2);
d([
  $("pie-switch")
], c.prototype, "_preferencesNodes", 2);
C(V, c);
export {
  O as ON_COOKIE_BANNER_ACCEPT_ALL,
  M as ON_COOKIE_BANNER_MANAGE_PREFS,
  S as ON_COOKIE_BANNER_NECESSARY_ONLY,
  N as ON_COOKIE_BANNER_PREFS_SAVED,
  c as PieCookieBanner,
  P as preferences
};
